import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PageHeader from "../Components/Pageheader";
import { Link } from "react-router-dom";
import "../assets/Css/checkout.css";

function Thankyou() {
	return (
		<>
			<Header />
			<PageHeader pagename="Thank You For Shopping" />
			<section className="thankyou-sec">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="thankyou-content text-center">
								<h5>Order Id #000369852147</h5>
								<h2>Congratulations</h2>
								<p>
									you have successfully purchased "To The Order." Enjoy your new
									acquisition and delve into its world of adventure and
									intrigue. Immerse yourself in its pages and let the story
									transport you to new realms of imagination and discovery.
								</p>
								<div className="btn-wrapper-thankyou">
									<Link className="btn-all order" to="/order-detail">
										View Order Details
									</Link>
									<Link className="btn-all shopping" to="/Shop">
										Continue Shopping
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
}

export default Thankyou;
